import { Component } from '@angular/core';
import { BehaviorSubject, finalize, Subscription } from 'rxjs';
import { ReportFilterInterface } from '../report-filter/report-filter.component';
import { Helper } from 'src/app/accountancy/utilities/classes/helper.class';
import { FormGroup } from '@angular/forms';
import { BarChartOptions } from 'src/app/accountancy/custom-components/acc-barchart/acc-barchart.component';

@Component({
  selector: 'app-cashflow-visual',
  templateUrl: './cashflow-visual.component.html',
  styleUrls: ['./cashflow-visual.component.scss']
})
export class CashflowVisualComponent {

  public readonly waitHandler = Helper.newWaitHandler();
  public readonly fg = this._newFg();
  public readonly properties$ = new BehaviorSubject<BarChartOptions | undefined>(Helper.chartOptions.bar);

  constructor() { }

  public onSubmit(body: ReportFilterInterface) {
    // request here
  }

  private _newFg() {
    const [year, month] = Helper.date.dateDestruct(new Date());

    return new FormGroup({
      GenerateBy: Helper.reactiveForms.control<string>('yearly'),
      YearStart: Helper.reactiveForms.control<number>(year - 3),
      YearEnd: Helper.reactiveForms.control<number>(year),
      Year: Helper.reactiveForms.control<number>(year),
      Month: Helper.reactiveForms.control<number>(month),
    });
  }

}
